import { REMOVE_REC_FROM_RECIPIENTS_WITHOUT_EMAIL_ARRAY } from "../../redux/actions/action.types";

export default function removeRecFromNoEmailArray(stateHandler: any, cartId: any) {
  stateHandler({
    type: REMOVE_REC_FROM_RECIPIENTS_WITHOUT_EMAIL_ARRAY,
    payload: cartId,
  });
}
